import { RocketAPI } from '@portal/rocket-api-client';
import { createFileRoute } from '@tanstack/react-router';

import EmailHistory from 'component/view/Settings/EmailHistory';

import { requireOperation } from './-guards';

export const Route = createFileRoute('/n/_auth/settings/_layout/email-history/')({
  beforeLoad: requireOperation({
    options: () => RocketAPI.billing.getListBillingEmailsQueryOptions(),
    redirectTo: '/n/dashboard',
  }),
  component: EmailHistory,
});
